import { render } from "./DynamicPrices.vue?vue&type=template&id=423c8d33"
import script from "./DynamicPrices.vue?vue&type=script&lang=js"
export * from "./DynamicPrices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__